interface GetURLSearchParamConfig {
    defaultValue: Maybe<string>;
    paramKey: string;
}

interface GetURLSearchParamsInput {
    configs: GetURLSearchParamConfig[];
    search: string;
}

export const getURLSearchParams = ({
    configs,
    search,
}: GetURLSearchParamsInput): Record<string, Maybe<string>> => {
    const searchParams = new URLSearchParams(search);

    return configs.reduce(
        (
            acc: Record<string, Maybe<string>>,
            curr: GetURLSearchParamConfig,
        ): Record<string, Maybe<string>> => {
            const lookup = searchParams.get(curr.paramKey);

            if (lookup === null) {
                acc[curr.paramKey] = curr.defaultValue;
            } else {
                acc[curr.paramKey] = decodeURIComponent(lookup);
            }

            return acc;
        },
        {},
    );
};
